import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

import './piv.css';
import logoIsq from '../media/images/STATir.svg';
import propTypes from 'prop-types';

class PIV extends Component {

    get labels() {
         return chainesLocales['PIV'][this.props.lngChild || 'FR'];
    }

    render() {
        return (
            <header className="Piv">
                <nav className="navbar navbar-expand-lg p-0 navbar-dark">
                    <div className="d-flex justify-content-between align-items-center piv-container">
                        <span className="navbar-brand p-0 logo-container text-left">
                            <img src={logoIsq} alt={this.labels.altLogoIsq} className="img-fluid" />
                        </span>

                        <button onClick={this.onNavbarTogglerClick} className="navbar-toggler" type="button" aria-controls="menuPiv" aria-label={this.labels.navbarTogglerLabel}>
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                    
                    <div className="collapse navbar-collapse justify-content-end" id="menuPiv">
                        <div className="navbar-nav liens-container text-right">
                            <a className="nav-item nav-link" href={this.props.lienFaq || this.labels.faqLinkHref} target="_blank" rel="noopener noreferrer">{this.labels.faqLinkText}</a>
                            <a className="nav-item nav-link" href={this.props.lienConfid || this.labels.confLinkHref} target="_blank" rel="noopener noreferrer">{this.labels.confLinkText}</a>
                            {
                                this.props.status === "ACTIF" ? <a className="nav-item nav-link" href="#consignes" role="button" onClick={this.showModal.bind(this, 'consignes')}>{this.labels.consignesLinkText}</a> : null
                            }
                            {
                                this.props.lienGuide ? <a className="nav-item nav-link" href={this.props.lienGuide} target="_blank" rel="noopener noreferrer">{this.labels.guideLinkText}</a> : null
                            }
                            {
                                this.props.lienDefinitions ? <a className="nav-item nav-link" href={this.props.lienDefinitions} target="_blank" rel="noopener noreferrer">{this.labels.definitionsLinkText}</a> : null
                            }
                            {
                                this.props.lienAnnexe ? <a className="nav-item nav-link" href={this.props.lienAnnexe} target="_blank" rel="noopener noreferrer">{this.labels.annexeLinkText}</a> : null
                            }
                            {
                                this.props.viewMode === "fullscreen" ? <a className="nav-item nav-link" href="#nous-joindre" role="button" onClick={this.showModal.bind(this, 'nous-joindre')} dangerouslySetInnerHTML={{__html: this.labels.contactUslinkText}} /> : null
                            }
                            {
                                this.renderQuit()
                            }
                        </div>
                    </div>
                </nav>
                            {
                                this.renderToggleLang()
                            }
            </header>
        );
    }

    onNavbarTogglerClick() {
        if (document.querySelector && document.body.classList) {
            if (document.querySelector('#menuPiv').classList.contains('show')) {
                document.querySelector('#menuPiv').classList.remove('show');
            } else {
                document.querySelector('#menuPiv').classList.add('show');
            }
        }
    }

    showModal(page = "", e) {
        e.preventDefault();

        if (page) {
            this.props.showModal(page);
        }
    }

    renderQuit() {
        /* TODO: Impossible de garantir une déconnexion Voxco à partir du piv de l'authentification donc pour l'instant
           on utilise un lien dans Voxco qui ouvre une page dans le iframe qui gère la deconnexion. Serait à voir éventuellement
           si on peut gérer cela à partir du piv de l'authentification */
        /*if (this.props.canQuitSurvey) {
            return (
                <a className="nav-item nav-link" href="#quitter" role="button" onClick={this.quitSurvey.bind(this)}>{this.labels.quitLinkText}</a>
            );
        }*/
        return null;
    }

    quitSurvey(evt) {
        evt.preventDefault();

        if (this.props.onQuitSurvey) {
            this.props.onQuitSurvey();
        }
    }
    // Handle language change
    handleLanguageChange = (event) => {
        this.setState({ lngChild: event.target.value });
    };
    /**
     * Permet de construire un select list dynamiquement
     * Construit les options selon la liste de langues de la collecte
     * Recoit un tableau de langues [id, nom]
     */

    createSelectFromList(arrayLangues) {
    return (
            <div className="alignRight">
                <select className="modern-select" id="language_selector" onChange={this.toggleLang.bind(this)} value={this.props.lngChild.toUpperCase()}>
                    {arrayLangues.map((langue) => (
                        <option value={langue.id}>{langue.nom}</option>
                ))}
                </select>
                <select className="modern-select" id="language_selectorVoxco" hidden={true} value={this.props.lngChild.toUpperCase()} onClick={this.toggleLangVoxco.bind(this)}>
                    {arrayLangues.map((langue) => (
                        <option value={langue.id}>{langue.nom}</option>
                ))}
                </select>
            </div>
            );
    }

    renderToggleLang() {
        if (this.props.canToggleLang && this.props.showLandButton?.includes(this.props.viewMode)) {
            const htmlOutput = this.createSelectFromList(this.props.langues);
            return htmlOutput;
        }
    }

    toggleLang(evt) {
        evt.preventDefault();
        let lng=document.getElementById('language_selector').value;
        if (this.props.onToggleLang) {
            this.props.onToggleLang(lng);
        }
    }

    toggleLangVoxco(evt) {
        evt.preventDefault();
        let lng=document.getElementById('language_selectorVoxco').value;
        if (this.props.onToggleLang) {
            this.props.onToggleLang(lng, true);
        }
    }

}

PIV.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired,
    langues: propTypes.string.isRequired,
    showLandButton: PropTypes.arrayOf(PropTypes.string).isRequired,
    canToggleLang: PropTypes.bool.isRequired,
    canQuitSurvey: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    viewMode: PropTypes.oneOf(['panel', 'fullscreen', 'iframe']),
    lienFaq: PropTypes.string,
    lienConfid: PropTypes.string,
    lienGuide: PropTypes.string,
    lienDefinitions: PropTypes.string,
    lienAnnexe: PropTypes.string
};

PIV.defaultProps = {
    lang: "FR",
    langues: "FR",
    showLandButton: ['panel', 'fullscreen', 'iframe'],
    canToggleLang: true,
    canQuitSurvey: false,
    user: {
        username: "",
        hasDefinedQuestion: false,
        hasDefinedSecret: false,
        hasDefinedMail: false
    },
    viewMode: "panel",
    lienFaq: "",
    lienConfid: "",
    lienGuide: "",
    lienDefinitions: "",
    lienAnnexe: ""
};

export default PIV;